import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Select from 'components/theme/Select'
import {
	contactSearch,
	selectContact,
	selectContactOrConversation,
} from 'actions/inbox'
import { createContact } from 'actions/contacts'
import { receiveContact } from 'actions/contacts/addOrEdit'
import { read } from 'actions/data'
import contactLabel from 'utils/contactLabel'
import Button from 'components/theme/Button'

export default connect(
	(state) => {
		const contactsArr = Object.values(state.contacts.contactsWithEmailsByID)

		const options = contactsArr
			.sort((a, b) => {
				if (a.first_name < b.first_name || !b.first_name) return -1
				if (a.first_name > b.first_name || !a.first_name) return 1
				return 0
			})
			.map((contact) => {
				const anyNames =
					contact?.first_name || contact?.middle_name || contact?.last_name

				const phoneLabels =
					contact?.phones?.map?.((phone) => phone?.number) || []

				const emailLabels =
					contact?.email?.map?.((email) => email?.address) || []

				const labelArr = anyNames
					? [
							contactLabel(contact)?.slice?.(0, -1),
							...emailLabels,
							...phoneLabels,
					  ]
					: [...emailLabels, ...phoneLabels]

				return {
					contactID: contact.id,
					value: contact.id,
					label: labelArr.join(', '),
					key: `${contact.id}ContactSelectValue`,
				}
			})

		// const allOptions = [...options, ...phoneOptions, ...emailOptions]
		const allOptions = options

		return {
			inputValue: state.inbox.contactSearch,
			value: state.inbox.contactSelected,
			allOptions,
		}
	},
	(dispatch) =>
		bindActionCreators(
			{
				contactSearch,
				selectContact,
				selectContactOrConversation,
				read,
				receiveContact,
				createContact,
			},
			dispatch,
		),
)(
	({
		value,
		inputValue,
		contactSearch,
		// selectContact,
		// contactsWithEmailsByID,
		// inbox,
		// selectConversation,
		read,
		receiveContact,
		allOptions,
		selectContactOrConversation,
		createContact,
	}) => {
		const customStyles = {
			control: (provided) => ({
				...provided,
				borderColor: 'rgba(0, 0, 0, 0.23)',
				borderRadius: '28px',
				padding: '9px 0',
			}),
			menu: (provided) => ({
				...provided,
				zIndex: 2,
			}),
		}

		const selectedValue = value
			? {
					// contactID: value.id,
					value: value.id,
					label: contactLabel(value),
					key: `${value.id}ContactSelectValue`,
			  }
			: null

		return (
			<div
				style={{ position: 'absolute', left: 15, width: 'calc(100% - 14px)' }}
			>
				<div style={{ display: 'inline-block', width: 'calc(100% - 100px)' }}>
					<Select
						creatable
						styles={customStyles}
						value={selectedValue}
						inputValue={inputValue}
						onChange={(newValue, actionObj) => {
							if (actionObj?.action === 'create-option') {
								if (newValue?.value?.indexOf('@') !== -1) {
									createContact({
										email: [
											{
												address: newValue?.value,
												opt_in: true,
												email_type: 'W',
											},
										],
									}).then((payload) => {
										selectContactOrConversation(payload?.id)
									})
								} else {
									let strippedNumber = newValue?.value
										?.replace(/[^0-9]+/g, '')
										.trim()
									const difference = strippedNumber?.length - 10
									if (difference > 0) {
										strippedNumber = strippedNumber.slice(difference)
									}
									if (strippedNumber?.length === 10) {
										createContact({
											phones: [
												{
													number: `+1${strippedNumber}`,
													opt_in: true,
													phone_type: 'M',
												},
											],
										}).then((payload) => {
											selectContactOrConversation(payload?.id)
										})
									}
								}
							} else {
								selectContactOrConversation(newValue?.contactID)
							}
						}}
						onInputChange={(string) => contactSearch(string)}
						options={allOptions}
						placeholder="Select a contact"
					/>
				</div>
				<div style={{ display: 'inline-block', marginLeft: 5 }}>
					<Button
						onClick={() => {
							contactSearch(null)
							selectContact(null)
						}}
						size="small"
					>
						Cancel
					</Button>
				</div>
			</div>
		)
	},
)
